<nav class="top-nav flex align-items-center justify-content-between">
  <div class="flex">
    <button class="backbutton px-3" [routerLink]="['/home']">
      <fa-icon class="fa-lg text-color" [icon]="faChevronLeft"></fa-icon>
    </button>
    <img
      *ngIf="currentTheme === 'light'"
      class="py-3"
      width="200"
      height="80"
      [src]="centralDarkLogo"
      alt=""
    />
    <img
      *ngIf="currentTheme === 'dark'"
      class="py-3"
      width="200"
      height="80"
      [src]="centralWhiteLogo"
      alt=""
    />
  </div>
  <div class="flex p-3 align-items-center gap-2">
    <!-- Theme Toggle Component -->
    <frontend-central-theme-toggle
      class="mr-3"
      (themeChange)="onThemeChange($event)"
    ></frontend-central-theme-toggle>

    <p-button
      variant="text"
      class="border-1 mr-3"
      [style.border-radius]="'5px'"
      [style.border-color]="'rgba(13, 91, 193, 0.5)'"
    >
      <div class="flex align-items-center gap-3">
        <span [style.font-weight]="'500'">{{ formattedOrgName$ | async }}</span>
        <fa-icon
          class="fa-sm"
          [style.color]="'var(--primary-400)'"
          [icon]="faUsersRectangle"
        ></fa-icon>
        <fa-icon
          class="fa-sm"
          [style.color]="'var(--primary-400)'"
          [icon]="faChevronDown"
        ></fa-icon>
      </div>
    </p-button>
    <fa-icon
      class="fa-lg mr-1"
      [icon]="faBell"
      [style.cursor]="'pointer'"
    ></fa-icon>
    <p-button variant="text" (click)="menu.toggle($event)"
      ><div class="flex align-items-center gap-3">
        <div class="profile-icon-bg">
          <fa-icon [icon]="faUser" [style.color]="'var(--surface-0)'"></fa-icon>
        </div>
        <div class="flex align-items-start flex-column">
          <div>
            {{ (user$ | async)?.fullname }}
          </div>
        </div>
        <fa-icon
          class="fa-sm"
          [icon]="faChevronDown"
          [style.color]="'var(--primary-400)'"
        ></fa-icon>
      </div>
    </p-button>
    <p-menu #menu [model]="profileItems" [popup]="true"> </p-menu>
  </div>
</nav>
<main>
  <nav class="side-nav">
    <!-- <br /> -->
    <a
      class="flex"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: false }"
      [class.disabled]="(hasDemandAccess$ | async) === false"
    >
      <p-button
        variant="text"
        class="flex flex-grow-1"
        [styleClass]="'flex flex-grow-1 justify-content-start border-noround'"
        [routerLink]="['/central/demand']"
      >
        <div class="py-1 pl-1 pr-2 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faChartLine"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Demand</span>
        </div>
      </p-button>
    </a>
    <a
      class="flex"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: false }"
      [class.disabled]="(hasAdvertisingAccess$ | async) === false"
    >
      <p-button
        variant="text"
        class="flex flex-grow-1"
        [styleClass]="'flex flex-grow-1 justify-content-start border-noround'"
        [routerLink]="['/central/advertising']"
      >
        <div class="py-1 pl-1 pr-2 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faPhoneLaptop"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Advertising</span>
        </div>
      </p-button>
    </a>
    <a
      class="flex"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: false }"
      [class.disabled]="(hasIntentAccess$ | async) === false"
    >
      <p-button
        variant="text"
        class="flex flex-grow-1"
        [styleClass]="'flex flex-grow-1 justify-content-start border-noround'"
        [routerLink]="['/central/intent']"
      >
        <div class="py-1 px-1 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faCommentsDollar"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Intent</span>
        </div>
      </p-button>
    </a>

    <a
      class="flex"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: false }"
      [class.disabled]="(hasIntentAccess$ | async) === false"
    >
      <p-button
        variant="text"
        class="flex flex-grow-1"
        [styleClass]="'flex flex-grow-1 justify-content-start border-noround'"
        [routerLink]="['/central/engagement-funnel']"
      >
        <div class="py-1 px-1 flex align-items-center">
          <div class="icon-sq">
            <!--Using custom SVG here because this icon is not available in Font Awesome.-->
            <img
              src="../../../assets/icons/engagement-funnel.svg"
              class="fa-lg"
              alt="Engagement Funnel"
            />
          </div>
          <span class="ml-3 text-lg left flex-grow-1">Engagement Funnel</span>
        </div>
      </p-button>
    </a>
    <!-- <a class="flex disabled">
      <p-button
        variant="text"
        class="w-full"
        [styleClass]="'flex w-full justify-content-start'"
      >
        <div class="py-1 pl-1 pr-2 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faEnvelope"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Email</span>
        </div>
      </p-button>
    </a>
    <a class="flex disabled">
      <p-button
        variant="text"
        class="w-full"
        [styleClass]="'flex w-full justify-content-start'"
      >
        <div class="py-1 pl-1 pr-2 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faTable"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Data</span>
        </div>
      </p-button>
    </a>
    <a class="flex disabled">
      <p-button
        variant="text"
        class="w-full"
        [styleClass]="'flex w-full justify-content-start'"
      >
        <div class="py-1 pl-1 pr-2 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faLightbulbGear"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Strategy</span>
        </div>
      </p-button>
    </a>
    <a class="flex disabled">
      <p-button
        variant="text"
        class="w-full"
        [styleClass]="'flex w-full justify-content-start'"
      >
        <div class="py-1 pl-1 pr-2 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faPalette"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Studio</span>
        </div>
      </p-button>
    </a>
    <a class="flex disabled">
      <p-button
        variant="text"
        class="w-full"
        [styleClass]="'flex w-full justify-content-start'"
      >
        <div class="py-1 pl-1 pr-2 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faCheckCircle"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Verify</span>
        </div>
      </p-button>
    </a>
    <a class="flex disabled">
      <p-button
        variant="text"
        class="w-full"
        [styleClass]="'flex flex-grow-1 justify-content-start'"
      >
        <div class="py-1 pl-1 pr-2 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faCalendar"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Events</span>
        </div>
      </p-button>
    </a>
    <a class="flex disabled">
      <p-button
        variant="text"
        class="w-full"
        [styleClass]="'flex flex-grow-1 justify-content-start'"
      >
        <div class="py-1 pl-1 pr-2 flex align-items-center">
          <div class="icon-sq">
            <fa-icon class="fa-lg" [icon]="faBriefcase"></fa-icon>
          </div>
          <span class="ml-3 text-lg inter">Partner</span>
        </div>
      </p-button>
    </a> -->
    <!-- <ng-container *ngIf="isAdmin$ | async">
      <a class="flex">
        <p-button
          variant="text"
          class="w-full"
          [styleClass]="
            'flex flex-grow-1  justify-content-start pr-1 border-noround'
          "
          (click)="showDataUniMenu = !showDataUniMenu"
        >
          <div class="p-1 flex align-items-center">
            <div class="icon-sq">
              <fa-icon
                class="fa-lg"
                [icon]="faSpaceStationMoonConstruction"
              ></fa-icon>
            </div>
            <span class="ml-3 text-lg inter text-left">Data Unification</span>
            <fa-icon
              class="fa-sm ml-2"
              [icon]="showDataUniMenu ? faChevronUp : faChevronDown"
            ></fa-icon>
          </div>
        </p-button>
      </a>
      <div [ngClass]="{ 'menu-slide': true, show: showDataUniMenu }">
        <ng-container *ngFor="let item of menuItems">
          <a routerLinkActive="active-link">
            <p-button
              variant="text"
              class="w-full border-noround"
              [styleClass]="'flex w-full justify-content-start'"
              [routerLink]="[item.link]"
            >
              <span class="ml-1 text-md inter">{{ item.label }}</span>
            </p-button>
          </a>
        </ng-container>
      </div>
    </ng-container> -->
  </nav>
  <div
    class="main-content flex w-full flex-column"
    [style.margin-right]="(globalPannel.visible | async) ? '4rem' : ''"
  >
    <div class="p-5 w-full">
      <router-outlet></router-outlet>
      @if (showNoAccess) {
      <h3>
        You do not have access to this application. Please contact DemandScience
        support for assistance.
      </h3>
      }
    </div>

    <frontend-global-side-panel #globalPannel></frontend-global-side-panel>

    <div class="bottom-nav flex items-center p-3 justify-between mt-auto">
      <span class="text-sm text-white"
        >©2025 DemandScience US, LLC All Rights Reserved</span
      >
      <tux-svg [src]="demandScienceLogoWhite" class="logo-scale"></tux-svg>
    </div>
  </div>
</main>

<ng-template #item let-item>
  <a [routerLink]="item.route" class="p-menu-item-link w-4rem">
    <span class="ml-2">{{ item.label }}</span>
  </a>
</ng-template>

<p-dialog
  [visible]="(showEULA$ | async) || false"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div>
      <h3 class="m-0 text-color">Updated Terms and Conditions</h3>
      <p class="text-sm text-gray-600 m-0 mt-1">
        Your acceptance is required to continue
      </p>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="eula-content">
      <p class="mb-3">
        We've updated our Terms of Service and Privacy Policy to better serve
        you and comply with new regulations. These changes include updated data
        processing terms, enhanced security measures, and clarified user
        responsibilities for lead generation and campaign management.
      </p>
      <p-button class="p-button-outlined mr-3">
        <div class="flex align-items-center gap-2">
          <fa-icon class="fa-lg mr-1" [icon]="faFileText"></fa-icon>
          <a
            href="https://demandscience.com/ionic-terms-of-service/"
            target="_blank"
            >Terms of Service</a
          >
        </div>
      </p-button>
      <div class="flex align-items-center mt-4">
        <p-checkbox
          inputId="eula-checkbox"
          [binary]="true"
          [(ngModel)]="eulaCheckbox"
          class="mr-2"
        ></p-checkbox>
        <label for="eula-checkbox" style="font-size: 0.95rem">
          I agree to the updated Terms of Service
        </label>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-3">
      <p-button
        label="Decline"
        (onClick)="declineEULA()"
        class="p-button-text"
      />
      <p-button
        label="Accept & Continue"
        (onClick)="acceptEULA()"
        class="p-button-text"
        [disabled]="!eulaCheckbox"
      />
    </div>
  </ng-template>
</p-dialog>
